import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container } from "react-bootstrap";
import { rSetShowFab } from "../../redux/reducers/GlobalVariables";
import CardHeadMenu from "../../Components/Card/CardHeadMenu/CardHeadMenu";
import configServ from "../../services/config";
import EmployeeHierarchyCard from "./EmployeeHierarchyCard";
import EmployeeHierarchyTable from "./EmployeeHierarchyTable";
import Swal from "sweetalert2";
import toast from "react-hot-toast";

const EmployeeHierarchyPage = () => {
  const { company_id, is_super, is_admin, permissions } = useSelector(
    (state) => state.GlobalVariables
  );
  const dispatch = useDispatch();

  const [isCreate, setIsCreate]   = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [hierarchyList, setHierarchyList] = useState([]);
  const [loader, setLoader]       = useState(false);
  const [page, setPage]           = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [total, setTotal]         = useState(0);

  const scrollToTop = () => window.scrollTo({ top: 0 });

  useEffect(() => { scrollToTop(); }, []);

  const handlePopup = () => {
    dispatch(rSetShowFab(isCreate));
    setIsCreate((p) => !p);
  };

  const fetchHierarchy = async () => {
    setLoader(true);
    try {
      const res = await configServ.getEmployeeHierarchy({
        company_id,
        page: page + 1,
        per_page: rowsPerPage,
      });
      if (res?.status) {
        setHierarchyList(res.data);
        setTotal(res.pagination?.total || res.data.length);
      } else {
        setHierarchyList([]);
        setTotal(0);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => { fetchHierarchy(); }, [page, rowsPerPage, isChanged]);

  const handleRemove = async (supervisor_id, subordinate_id) => {
    const result = await Swal.fire({
      title: "Remove Hierarchy Link?",
      text: "This will remove the supervisor-subordinate relationship.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, remove",
    });
    if (!result.isConfirmed) return;

    try {
      const res = await configServ.removeEmployeeHierarchy({
        company_id,
        supervisor_id,
        subordinate_id,
      });
      if (res?.status) {
        toast.success("Hierarchy link removed");
        setIsChanged((p) => !p);
      } else {
        toast.error(res?.message || "Failed to remove");
      }
    } catch (e) {
      toast.error("Something went wrong");
      console.error(e);
    }
  };

  return (
    <Container>
      <CardHeadMenu
        prefix="Na"
        suffix="Na"
        title="EMPLOYEE HIERARCHY"
        handlePopup={handlePopup}
        isEdit={false}
        create={isCreate}
        showCreate={Boolean(is_super || is_admin || permissions?.includes(84))}
      />

      {isCreate && (
        <EmployeeHierarchyCard
          company_id={company_id}
          setIsCreate={setIsCreate}
          setIsChanged={setIsChanged}
        />
      )}

      <EmployeeHierarchyTable
        hierarchyList={hierarchyList}
        loader={loader}
        page={page}
        rowsPerPage={rowsPerPage}
        total={total}
        setPage={setPage}
        setRowsPerPage={setRowsPerPage}
        handleRemove={handleRemove}
      />
    </Container>
  );
};

export default EmployeeHierarchyPage;
